<template>
  <div class="feedGroupHeader">
    <input
      type="text"
      class="feedGroupHeader-name"
      v-model="feedGroupName"
      placeholder="..."
    >
    <div class="feedGroupHeader-manageFeedGroupHolder">
      <div class="feedGroupHeader-manageFeedGroupButtonHolder">
        <button-com
          :iconName="(visible) ? 'arrow-up' : 'arrow-down'"
          iconSize="large"
          iconCircleColor="#E9E9E9"
          :tooltip="(visible) ? `Hide Fields` : `Show Fields`"
          class="bm-ghost bm-onlyIcon"
          @click.native="visible = !visible"
        ></button-com>
      </div>
      <div class="feedGroupHeader-manageFeedGroupButtonHolder">
        <button-com
          :iconName="public ? 'public' : 'private'"
          iconSize="large"
          iconCircleColor="#E9E9E9"
          :tooltip="public ? `Make Private` : `Make Public`"
          class="bm-ghost bm-onlyIcon"
          @click.native="public = !public"
        ></button-com>
      </div>
      <div class="feedGroupHeader-manageFeedGroupButtonHolder">
        <button-com
          iconName="delete"
          iconSize="large"
          iconCircleColor="#E9E9E9"
          tooltip="Delete"
          class="bm-ghost bm-onlyIcon"
          @click.native="deleteFeed"
        ></button-com>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['feedGroupIndex', 'feedIndex'],
  methods: {
    getInput (key) {
      const feeds = this.$store.state.feeds
      const feedGroup = feeds[this.feedGroupIndex]
      const feed = feedGroup[this.feedIndex]
      const input = feed[0]
      return input[key]
    },
    updateFeedGroupHeader (key, value) {
      this.$store.commit({
        type: 'updateFeedGroupHeader',
        key: key,
        value: value,
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex
      })
    },
    deleteFeed () {
      this.$store.commit({
        type: 'deleteFeed',
        feedGroupIndex: this.feedGroupIndex,
        feedIndex: this.feedIndex
      })
    }
  },
  computed: {
    feedGroupName: {
      get () {
        return this.getInput('value')
      },
      set (value) {
        this.updateFeedGroupHeader('value', value)
      }
    },
    visible: {
      get () {
        return this.getInput('visible')
      },
      set (value) {
        this.updateFeedGroupHeader('visible', value)
      }
    },
    public: {
      get () {
        return this.getInput('public')
      },
      set (value) {
        this.updateFeedGroupHeader('public', value)
      }
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('feedGroupHeader')
  position: relative
  display: flex
  align-items: center

  +element('name')
    height: 70px
    border: none
    border-radius: 0
    font-size: 14px
    padding: 0 185px 0 30px
    background-color: transparent
    box-shadow: none

  +element('manageFeedGroupHolder')
    position: absolute
    right: 15px
    display: flex

  +element('manageFeedGroupButtonHolder')
    margin-left: 5px
    width: 40px
    height: 40px

</style>



// WEBPACK FOOTER //
// src/components/FeedGroupHeader.vue